(function($) {

    $.fn.playlisteditor = function( options ) {

        var $elem = this;
        var settings = $.extend({
            side_duration: 600,
            uploads_api: '/api/uploads',
            records_api: '/api/records',
            next_step: '/step2'
        }, options);

        var max_duration_side = settings.side_duration;
        var duration_total = 0;
        var duration_side_a = 0;
        var duration_side_b = 0;
        var csrftoken = $('input[name="_token"]').val();

        var catalog_page = null;
        var catalog_query = null;

        var previewTemplate = $elem.find('.playlist-upload').get(0).outerHTML;
        $elem.find('.playlist-upload').remove();
        $elem.find('.playlist-editor-uploads').show();

        var songTemplate = $elem.find('.playlist-song-template .playlist-song').get(0).outerHTML;
        $elem.find('.playlist-song-template').remove();

        var clickable = $('.playlist-editor-controls-add');
        var previewContainer = $elem.find('.playlist-editor-uploads');

        $('.playlist-editor-controls-find').click(function(e) {
            e.preventDefault();

            $('.catalog').catalog({
                callback: function(data, page, query) {
                    console.log(page);
                    catalog_page = page;
                    catalog_query = query;
                    addSong(data);
                },
                page: catalog_page,
                query: catalog_query
            });
        });

        $('.playlist-editor-controls-save').click(function(e) {
            e.preventDefault();
            savePlaylist();
        });

        $elem.on('click', '.playlist-song-delete > a', function(e) {
            var $song = $(this).parents('.playlist-song');
            var slug = $song.attr('id');

            $.ajax({ url: settings.uploads_api +'/'+slug, type: 'DELETE', data: { _token: csrftoken } });

            $song.remove();
            resetDuration();

            if($('.playlist-song').length === 0) {
                $elem.find('.playlist-no-files').show();
            }
        });


        $elem.on('click', '.playlist-song-edit > a, .playlist-song:not(.playlist-no-files) > .playlist-song-name', function(e) {
            var $song = $(this).parents('.playlist-song');
            var slug = $song.attr('id');

            $song.find('.playlist-song-name').songeditor({
                slug: slug,
                finished: saveSong
            });
        });


        $elem.fileuploader({
            'clickable' : clickable,
            'previewContainer' : previewContainer,
            'previewTemplate' : previewTemplate,
            'addSongFunction' : addSong
        });


        $elem.find('.playlist-editor-sides').sortable({
            axis: 'y',
            items: '.playlist-song',
            update: function( event, ui ) {
                resetDuration();
            }
        });


        resetDuration();

        function addSong(data) {
            var duration = parseInt(data.duration);
            var title = data.title ? data.title : data.original_name.replace(/\.[^/.]+$/, "");
            var artist = data.artist ? data.artist : 'Unknown';
            var slug = data.slug;

            $song = $(songTemplate);
            $song.attr('id', slug);
            $song.data('duration', duration);
            $song.find('.playlist-song-name > .artist').html(artist);
            $song.find('.playlist-song-name > .song').html(title);
            $song.find('.playlist-song-time').html(secondsToString(duration));

            var side = (duration_side_a + duration <= max_duration_side) ? 'a' : 'b';
            var $last_song = $elem.find('.playlist-side-'+side+' .playlist-song:last');

            if($last_song.length > 0) {
                $last_song.after($song);
            } else {
                $elem.find('.playlist-side-'+side).prepend($song);
            }

            resetDuration();
            $elem.find('.playlist-editor-sides').sortable('refresh');
        }


        function saveSong(slug, artist, title) {
            var $song = $("#"+slug);
            $song.find('.playlist-song-name').html('<span class="artist">'+artist+'</span> - <span class="song">'+title+'</span>');
        }


        function resetDuration() {
            duration_total = 0;
            duration_side_a = 0;
            duration_side_b = 0;


            $('.playlist-side-a > .playlist-song:not(.playlist-no-files)').each(function(i, v)
            {
                duration_total += parseInt($(v).data('duration'));
                duration_side_a += parseInt($(v).data('duration'));
            });

            $('.playlist-side-b > .playlist-song:not(.playlist-no-files)').each(function(i, v)
            {
                duration_total += parseInt($(v).data('duration'));
                duration_side_b += parseInt($(v).data('duration'));
            });

            updateSideDurations();
        }


        function updateSideDurations() {
            $elem.find('.playlist-side-a .playlist-side-total-time > span').html(secondsToString(duration_side_a));
            validateSide('a');

            $elem.find('.playlist-side-b .playlist-side-total-time > span').html(secondsToString(duration_side_b));
            validateSide('b');
        }


        function validateSide(side) {

            if($elem.find('.playlist-side-'+side+' .playlist-song:not(.playlist-no-files)').length === 0) {
                $elem.find('.playlist-side-'+side+' .playlist-no-files').show();
            } else {
                $elem.find('.playlist-side-'+side+' .playlist-no-files').hide();
            }

            var duration = (side == 'a') ? duration_side_a : duration_side_b;

            if(duration > max_duration_side) {
                $elem.find('.playlist-side-'+side+' .playlist-side-total-time').addClass('error');
            } else {
                $elem.find('.playlist-side-'+side+' .playlist-side-total-time').removeClass('error');
            }

            if($elem.find('.playlist-side-total-time.error').length > 0) {
                $('.playlist-editor-controls-save').prop('disabled', true);
            } else {
                $('.playlist-editor-controls-save').prop('disabled', false);
            }
        }


        function secondsToString(seconds) {
            var mins = Math.floor(seconds / 60);
            seconds = seconds % 60;
            seconds = ("0" + seconds).slice(-2);
            return mins + ':' + seconds;
        }


        function savePlaylist(force) {

            var side_a = [];
            var side_b = [];

            $elem.find('.playlist-side-a > .playlist-song:not(.playlist-no-files)').each(function(i,v) {
                side_a.push({
                    id: $(v).attr('id'),
                    artist: $(v).find('.artist').html(),
                    title: $(v).find('.song').html()
                });
            });

            $elem.find('.playlist-side-b > .playlist-song:not(.playlist-no-files)').each(function(i,v) {
                side_b.push({
                    id: $(v).attr('id'),
                    artist: $(v).find('.artist').html(),
                    title: $(v).find('.song').html()
                });
            });

            if(!force) {
                console.log(side_a.length, side_b.length);
                if(side_a.length == 0 && side_b.length == 0) {
                    $.errormodal('Error', 'Oops! It seems you haven\'t uploaded any music. Upload your music by hitting the CHOOSE FILE(S) button.', 'Got it');
                    return;
                } else if(side_a.length == 0 || side_b.length == 0) {
                    $.buttonmodal('Just checking', 'Are you sure you want to continue without adding music to the other side of your vinyl? Click yes to continue or close this box (X) to add more music.', 'Yes', function($modal) {
                        $modal.close();
                        savePlaylist(true);
                    });
                    return;
                }
            }

            $.post(settings.records_api, {
                side_a: side_a,
                side_b: side_b,
                _token: csrftoken
            }, function(data) {
                // Track facebook add to cart
                fbq('track', 'AddToCart');

                window.location = settings.next_step;
            }).fail(function(data) {
                $.errormodal('Error', 'Oops! It seems something went wrong while saving. We\'ve notified our administrators and will try to fix the error soon. Meanwhile, maybe try again?', 'OK');
            });
        }
    };


}( jQuery ));